
(function () {
  const siteHeader = document.querySelector('.section-header');
  if (!siteHeader) return;

  function updateStorefrontHeaderTop() {
    const isPageHeaderHidden = siteHeader.classList.contains('shopify-section-header-hidden');
    const distanceWithHeaderShown = siteHeader.getBoundingClientRect().height + 8;
    const distanceWithHeaderHidden = 32;
    const topDistance = isPageHeaderHidden ? distanceWithHeaderHidden : distanceWithHeaderShown;
    document.documentElement.style.setProperty('--storefront-header-top', `${topDistance}px`);
  }

  updateStorefrontHeaderTop();
  new ResizeObserver(updateStorefrontHeaderTop).observe(siteHeader);
  new MutationObserver(updateStorefrontHeaderTop).observe(siteHeader, { attributeFilter: ['class'] });
})();

(function () {
  const sections = document.querySelectorAll('.product-grid-section');

  sections.forEach((section) => {
    const track = section.querySelector('[data-carousel-track]');
    const prevBtn = section.querySelector('[data-carousel-prev]');
    const nextBtn = section.querySelector('[data-carousel-next]');

    if (!track || !prevBtn || !nextBtn) return;

    function updateButtonStates() {
      const scrollLeft = track.scrollLeft;
      const scrollWidth = track.scrollWidth;
      const clientWidth = track.clientWidth;

      prevBtn.disabled = scrollLeft === 0;
      nextBtn.disabled = scrollLeft >= scrollWidth - clientWidth - 10;
    }

    function scrollCarousel(direction) {
      const cardWidth = track.querySelector('[data-product-card]')?.offsetWidth || 250;
      const gap = parseInt(getComputedStyle(track).gap) || 16;
      const pageDistance = cardWidth + gap;
      const cardsPerStep = window.matchMedia('(max-width: 749px)').matches ? 1 : 2;
      const distance = pageDistance * cardsPerStep;

      track.scrollBy({
        left: direction === 'next' ? distance : -distance,
        behavior: 'smooth',
      });

      setTimeout(updateButtonStates, 300);
    }

    prevBtn.addEventListener('click', () => scrollCarousel('prev'));
    nextBtn.addEventListener('click', () => scrollCarousel('next'));
    track.addEventListener('scroll', updateButtonStates);

    updateButtonStates();
  
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        e.preventDefault();
        scrollCarousel(e.key === 'ArrowLeft' ? 'prev' : 'next');
      }
    });
  });

  const productForms = document.querySelectorAll('.product-card__form');
  productForms.forEach((form) => {
    form.addEventListener('submit', async (e) => {
      const button = form.querySelector('.product-card__button');
      const originalText = button.textContent;
      if (!window.fetch) return;

      e.preventDefault();
      button.disabled = true;
      button.textContent = 'Adicionando...';

      try {
        const formData = new FormData(form);
        const variantId = formData.get('id');
        const quantity = formData.get('quantity') || 1;

        const cartDrawer = document.querySelector('cart-drawer');
        const sections =
          cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
            ? cartDrawer.getSectionsToRender().map((s) => s.id)
            : [];

        // XHR instead of fetch: a third-party script wraps window.fetch and resolves to
        // undefined, which broke the response handling even though the item was added.
        const result = await postJSON('/cart/add.js', {
          id: variantId,
          quantity,
          sections,
          sections_url: window.location.pathname,
        });

        showToast(result.title, result.featured_image?.url);

        if (typeof updateCartDrawer === 'function') {
          updateCartDrawer({ ...result, id: variantId });
        }

        button.textContent = originalText;
        button.disabled = false;
      } catch (error) {
        button.textContent = 'Erro - Tentar novamente';
        button.disabled = false;
        console.error('Cart error:', error);
        setTimeout(() => {
          button.textContent = originalText;
        }, 3000);
      }
    });
  });

  function postJSON(url, body) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', url);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.onload = () => {
        if (xhr.status < 200 || xhr.status >= 300) {
          reject(new Error(`Failed to add product (${xhr.status})`));
          return;
        }
        try {
          resolve(JSON.parse(xhr.responseText));
        } catch (err) {
          reject(err);
        }
      };
      xhr.onerror = () => reject(new Error('Network error'));
      xhr.send(JSON.stringify(body));
    });
  }

  function enableDragScroll(track) {
    if (!track) return;
    let startX = 0;
    let scrollLeft = 0;
    let isDown = false;

    track.addEventListener('mousedown', (e) => {
      isDown = true;
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
      track.style.cursor = 'grabbing';
    });

    track.addEventListener('mouseleave', () => {
      isDown = false;
      track.style.cursor = 'grab';
    });

    track.addEventListener('mouseup', () => {
      isDown = false;
      track.style.cursor = 'grab';
    });

    track.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - track.offsetLeft;
      const walk = x - startX;
      track.scrollLeft = scrollLeft - walk;
    });
  }

  sections.forEach((section) => {
    enableDragScroll(section.querySelector('[data-carousel-track]'));
  });

  document.querySelectorAll('.product-storefront-grid__filter-chips-track').forEach(enableDragScroll);

  function showToast(productName, productImage) {
    const toast = document.querySelector('.toast-notification');
    if (toast) {
      const toastProductName = toast.querySelector('.toast-notification__product-title');
      toastProductName.textContent = productName;
      const toastProductImage = toast.querySelector('.toast-notification__product-image');
      if (toastProductImage && productImage) {
        toastProductImage.src = productImage;
      }
      setTimeout(() => {
        toast.classList.add('active');
      }, 100);

      setTimeout(() => {
        toast.classList.remove('active');
      }, 5000);
    }
  }
})();
